import React, { FC, useCallback } from 'react'
import { useFormikContext } from 'formik'

import { Child } from '../../types'
import { Icons } from '../Icon'
import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type DeclarationMemberListProps = {
  className?: string
  addMemberButton: ActionButtonProps
  shouldResetForm?: boolean
  members: (Child & {
    button?: ActionButtonProps
  })[]
}

const DeclarationMemberList: FC<DeclarationMemberListProps> = (props) => {
  const { className, addMemberButton, members, shouldResetForm = true } = props

  const { values, resetForm } = useFormikContext()

  const handleAddMember = useCallback(() => {
    if (!addMemberButton?.onClick) return
    addMemberButton?.onClick(values as any)
    if (!shouldResetForm) return
    resetForm()
  }, [resetForm, addMemberButton, values, shouldResetForm])

  return (
    <SC.Container className={className}>
      {members.map((member, index) => (
        <SC.Member key={index}>
          <SC.StyledIcon icon={Icons.enfant} />
          <SC.MemberInfo>
            {member.civility} {member.lastName} {member.firstName}
          </SC.MemberInfo>
          {member.button && <SC.StyledActionButton noTextOnMobile {...member.button} />}
        </SC.Member>
      ))}
      <SC.AddMemberButton {...addMemberButton} onClick={handleAddMember} />
    </SC.Container>
  )
}

export default DeclarationMemberList
